import { render } from "./AssetTypeEdit.vue?vue&type=template&id=5b5def13"
import script from "./AssetTypeEdit.vue?vue&type=script&lang=js"
export * from "./AssetTypeEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__